// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_XiK","cls2":"Carousel-cls2_5vD Carousel-cls1_XiK"};